/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon20Light = forwardRef('ArrowARightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.365 3.291a.5.5 0 1 1 .707-.707l5.237 5.237a2.375 2.375 0 0 1 0 3.358l-5.237 5.237a.5.5 0 1 1-.707-.707l5.237-5.237c.139-.139.242-.3.309-.472H2.5a.5.5 0 1 1 0-1h14.41a1.37 1.37 0 0 0-.308-.472L11.365 3.29Z" })));
});
